/* eslint-disable */
import {execute, grable} from '../concrete'

const concreteModuleName = 'concrete'

const AdministratorService = {
    /**
     * 重置密码
     * @param {*} userId 管理员ID
     * @returns Promise 
     */
    'resetPassword': function (userId) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '8a335e9605c61301d60220b8b399202db987f018', userId)
            : execute(concreteModuleName, `/CooperativeService/resetPassword`, 'json', 'POST', { userId });
    }, 
    /**
     * 获取用户级别
     * @returns Promise 
     */
    'userLevelInfo': function () {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'f72fd54f6fed4a93a400f635fc04c5baf6ce79f8')
            : execute(concreteModuleName, `/CooperativeService/userLevelInfo`, 'json', 'GET');
    }, 
    /**
     * 获取所属区域
     * @param {*} getAreaInfoPo 获取所属区域的对象
     * @returns Promise 
     */
    'AreaInfoList': function (getAreaInfoPo) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '6eeaf472a05b3b04c08fb74c5da1d1992eb193f5', getAreaInfoPo)
            : execute(concreteModuleName, `/CooperativeService/AreaInfoList`, 'json', 'POST', getAreaInfoPo);
    }, 
    /**
     * 查询管理员信息列表
     * @param {*} poPageRequest 
     * @returns Promise 
     */
    'administratorInfoList': function (poPageRequest) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'ac1b38afd8dd5b5497e66c2e897aa5acecf487d8', poPageRequest)
            : execute(concreteModuleName, `/CooperativeService/administratorInfoList`, 'json', 'POST', poPageRequest);
    }, 
    /**
     * 修改管理员信息
     * @param {*} updateUserInfoPo 
     * @returns Promise 
     */
    'changeAdminInfo': function (updateUserInfoPo) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '68ce5404707510e0c834dd4c3c4e61406c407d9a', updateUserInfoPo)
            : execute(concreteModuleName, `/CooperativeService/changeAdminInfo`, 'json', 'POST', updateUserInfoPo);
    }, 
    /**
     * 添加管理员信息
     * @param {*} addUserInfoPo 
     * @returns Promise 
     */
    'addAdminInfo': function (addUserInfoPo) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '91993fbf10ba7163b7b0cca2d90ce6d4a3087a77', addUserInfoPo)
            : execute(concreteModuleName, `/CooperativeService/addAdminInfo`, 'json', 'POST', addUserInfoPo);
    }, 
    /**
     * 根据 UserId 查询管理员的信息
     * @param {*} userId 管理员ID
     * @returns Promise 
     */
    'administratorInfoByUserId': function (userId) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'f5483f96ad444d2295d6abbd103d730da2a5c291', userId)
            : execute(concreteModuleName, `/CooperativeService/administratorInfoByUserId`, 'json', 'POST', { userId });
    }, 
    /**
     * 删除管理员
     * @param {*} userId 管理员ID
     * @returns Promise 
     */
    'removeAdminInfo': function (userId) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '834fe5ce7003c00b13de43ebab2cd4759c69e35d', userId)
            : execute(concreteModuleName, `/CooperativeService/removeAdminInfo`, 'json', 'POST', { userId });
    }, 
    /**
     * 修改密码
     * @param {*} changePassword 
     * @returns Promise 
     */
    'changePassword': function (changePassword) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '4f1216ffbc523d267815ca791593174cd0c58ee1', changePassword)
            : execute(concreteModuleName, `/CooperativeService/changePassword`, 'json', 'POST', changePassword);
    }
}

export default AdministratorService
